/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import UserApplications from "./ApplicationList";

const ApplicationViewDialog = ({ open, handleClose }) => {
  const { activeSession } = useSelector(({ auth }) => auth);

  return (
    <Dialog fullWidth open={open} maxWidth={"xl"}>
      <DialogTitle id="responsive-dialog-title">
        <span>
          <b>My Applications</b>
        </span>
      </DialogTitle>

      <DialogContent>
        <UserApplications entity={activeSession?.INCORPORATION_NUMBER} />
      </DialogContent>

      <DialogActions>
        <Button
          size="small"
          id="btn-close"
          margin="dense"
          color="secondary"
          variant="contained"
          onClick={handleClose}
          style={{ marginLeft: "10px" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApplicationViewDialog;
